export var FlakePrefixes;
(function (FlakePrefixes) {
    FlakePrefixes["Path"] = "p";
    FlakePrefixes["List"] = "li";
    FlakePrefixes["ListRow"] = "lr";
    FlakePrefixes["ListProperty"] = "lp";
    FlakePrefixes["ListCell"] = "lc";
    FlakePrefixes["Workspace"] = "ws";
    FlakePrefixes["Connection"] = "con";
    FlakePrefixes["Flow"] = "flo";
    FlakePrefixes["Node"] = "nod";
    FlakePrefixes["Run"] = "ru";
    FlakePrefixes["Billing"] = "bil";
    FlakePrefixes["Account"] = "acc";
})(FlakePrefixes || (FlakePrefixes = {}));
